import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';
import useSWR, { mutate } from 'swr';

const CategoryTypeForm = ({ state, updateField, errors, prod_id }) => {
    const { data: production_data, error: production_error, isLoading: production_loading } = useSWR('/productions');

    return (
        <Box p={4} display="flex" justifyContent="center" alignItems="center">
            <Grid container spacing={2}>

                {/* Production */}
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth size="small" error={!!errors.pc_pruduction_id}>
                        <Autocomplete
                            id="pc_pruduction_id"
                            options={Array.isArray(production_data) ? production_data : []}
                            getOptionLabel={(option) => option.p_descr || ""}
                            value={Array.isArray(production_data) ? production_data?.find(expense_category => expense_category.id === (state?.pc_pruduction_id || prod_id)) || null
                                : null}
                            onChange={(event, newValue) => {
                                const selectedClientId = newValue ? newValue.id : "";
                                updateField("pc_pruduction_id", selectedClientId);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: 40,
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '0.975rem',
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: 0,
                                        },
                                    }}
                                    label="Παραγωγή"
                                    error={!!errors.pc_pruduction_id}
                                    helperText={errors.pc_pruduction_id || null}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </FormControl>
                </Grid>

                {/* Description */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        size="small"
                        fullWidth
                        label="Περιγραφή"
                        value={state?.pct_descr || ""}
                        onChange={e => updateField("pct_descr", e.target.value)}
                        error={!!errors.pct_descr}
                        helperText={errors.pct_descr}
                    />
                </Grid>

                {/* AA */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        size="small"
                        fullWidth
                        label="A/A"
                        value={state?.pct_aa || ""}
                        onChange={e => updateField("pct_aa", Number(e.target.value))}
                        error={!!errors.pct_aa}
                        helperText={errors.pct_aa}
                    />
                </Grid>

            </Grid>
        </Box>
    );
};

export default CategoryTypeForm;
